const STORAGE_PREFIX = "vg-organizer-banner-mode-v1";

const storageKey = (userId) => {
  const id = Number(userId);
  return Number.isSafeInteger(id) && id > 0 ? `${STORAGE_PREFIX}:${id}` : null;
};

export const readOrganizerBannerMode = (userId) => {
  const key = storageKey(userId);
  if (!key || typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(key);
    return value === "panel" || value === "create" ? value : null;
  } catch {
    return null;
  }
};

export const writeOrganizerBannerMode = (userId, mode) => {
  const key = storageKey(userId);
  if (!key || typeof window === "undefined" || !["panel", "create"].includes(mode)) return;
  try {
    window.localStorage.setItem(key, mode);
  } catch {
    // The banner still updates in memory if local storage is unavailable.
  }
};
